
import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';

import { useNavigate, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { GET_STOCK_TRANSFER_LIST, APPROVE_STOCK_TRANSFER_REQUEST } from '../../../common/URLs';
import jwt from 'jwt-decode';
import { Container, Button, Box, Card, IconButton, Tooltip, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Tab } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PROD } from "../../../common/constants";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Clear as CancelIcon, Done as ApproveIcon } from '@mui/icons-material';
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { Send as SendIcon } from '@mui/icons-material';
import { ViewIcon } from "../../../common/icons";
import apiClient from "../../../axios";

function StockTransferApproval() {

    const navigate = useNavigate();
    const decoded = jwt(getLocalStorageItem('id_token'));
    const { state } = useLocation();
    const [stockListData, setStockListData] = useState();
    const [bulkApproveStockTransfer, setBulkApproveStockTransfer] = useState();
    const [stockList, setStockList] = useState([]);
    const [tabValue, setTabValue] = useState(state?.tabVal ? state?.tabVal : "0");

    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);

    const [confirmOpen2, setConfirmOpen2] = useState(false);
    const handleConfirmOpen2 = () => setConfirmOpen2(true);
    const handleConfirmClose2 = () => setConfirmOpen2(false);

    useEffect(() => {
        getStockTransferRequestList();
    }, [tabValue]);

    const getStockTransferRequestList = (e) => {
        loaderService.showLoader();
        apiClient
            .post(GET_STOCK_TRANSFER_LIST,
                {
                    // "stakeHolderUrn": "string",
                    "approvalStatus": tabValue,
                    // "isOrderGenerated": false,
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setStockListData(response.data.stockTransferDetailsList);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }


    const onViewDetails = (cellValues) => {
        // navigate('./sto', {
        //     state: { selectedRow: cellValues.row, screen: "ApprovalList", tabVal: tabValue }
        // });
    }

    const columns = [
        { field: 'stockTransferNumber', headerName: 'Stock Transfer Number', width: 180 },
        { field: 'requestStakeholderType', headerName: 'Transfer Type', width: 150 },
        { field: 'financialYear', headerName: 'Financial Year', width: 120 },
        { field: 'month', headerName: 'Month', width: 120 },
        {
            field: 'materialType', headerName: 'Material Type', width: 150,
            valueGetter: (params) => {
                if (params.row.materialType === "RawBamboo" || params.row.materialType === "rawbamboo") {
                    return "Raw Bamboo"
                } else if (params.row.materialType === "ChipBamboo" || params.row.materialType === "chipbamboo") {
                    return "Chip Bamboo"
                }
                else return ""

            }
        },
        { field: 'stockTransferQuantity', headerName: 'Quantity', width: 140 },
        { field: 'sourceStakeholderType', headerName: "Source Type", width: 150 },
        { field: 'sourceStakeholderUrn', headerName: "Source URN", width: 150 },
        { field: 'sourceStakeholderName', headerName: "Source Name", width: 200 },
        { field: 'sourceStakeholderAddress', headerName: 'Source Address', width: 250 },
        { field: 'destinationStakeholderType', headerName: "Destination Type", width: 150 },
        { field: 'destinationStakeholderUrn', headerName: "Destination URN", width: 150 },
        { field: 'destinationStakeholderName', headerName: "Destination Name", width: 150 },
        { field: 'destinationStakeholderAddress', headerName: 'Destination Address', width: 250 },
        // {
        //     field: 'Action', width: 100,
        //     renderCell: (cellValues) => {
        //         return (
        //             <Tooltip title="View">
        //                 <IconButton
        //                     variant="contained"
        //                     color="primary"
        //                     onClick={() => onViewDetails(cellValues)}
        //                 >
        //                     <ViewIcon />
        //                 </IconButton>
        //             </Tooltip>
        //         );
        //     }
        // },
    ];

    const onApprove = (e) => {
        toApproveBulk(true);
    }
    const onReject = (e) => {
        toApproveBulk(false);
    }

    const onConfirmApprove = (e) => {
        handleConfirmClose();
        onApprove(e);
    }

    const onApproveButtonClick = (e) => {
        handleConfirmOpen();
    }

    const onConfirmReject = (e) => {
        handleConfirmClose2();
        onReject(e);
    }

    const onRejectButtonClick = (e) => {
        handleConfirmOpen2();
    }

    const toApproveBulk = (approval) => {
        loaderService.showLoader();
        apiClient
            .post(APPROVE_STOCK_TRANSFER_REQUEST,
                {
                    "requestIdList":
                        stockList
                    ,
                    "isRequestApproved": approval,
                    "approvedBy": localStorage.getItem('InspectorEmail')
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setBulkApproveStockTransfer(response.data);
                getStockTransferRequestList();
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    useEffect(() => {
        if (bulkApproveStockTransfer) {
            if (bulkApproveStockTransfer.isSuccess === true) {
                toast.success(bulkApproveStockTransfer?.message)
            }
            else {
                toast.error(bulkApproveStockTransfer?.message ? bulkApproveStockTransfer?.message : "Error")
            }
        }
    }, [bulkApproveStockTransfer]);

    const handleTabChange = (e, newValue) => {
        setTabValue(newValue);
    }


    return (
        <>
            <Container maxWidth="xxl">
                <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
                    <Typography variant="h4" gutterBottom>
                        Stock Transfer Request Approval
                    </Typography>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
                        <Stack direction="row" spacing={1}>
                            <Button variant="contained" hidden={tabValue == '1' || tabValue === '2'} disabled={stockList?.length < 1} onClick={(e) => onApproveButtonClick(e)} startIcon={<ApproveIcon />}>
                                Approve
                            </Button>
                            <Button variant="contained" hidden={tabValue == '1' || tabValue === '2'} disabled={stockList?.length < 1} onClick={(e) => onRejectButtonClick(e)} startIcon={<CancelIcon />}>
                                Reject
                            </Button>
                        </Stack>
                    </Stack>
                </Stack>
                <Card>
                    <TabContext value={tabValue}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: "whitesmoke" }}>
                            <TabList onChange={handleTabChange} >
                                <Tab label="Stock Transfer Request Approval List" value="0" />
                                <Tab label="Stock Transfer Request Approved List" value="1" />
                            </TabList>
                        </Box>
                        <TabPanel value="0">
                            <Box style={{ height: 450, width: '100%' }}>
                                {
                                    stockListData &&
                                    <DataGrid
                                        sx={{
                                            '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '6px' },
                                            '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '12px' },
                                            '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '20px' },
                                        }}
                                        getRowHeight={() => 'auto'}
                                        rows={stockListData}
                                        columns={columns}
                                        pageSize={10}
                                        checkboxSelection
                                        components={{ Toolbar: QuickSearchToolbar }}
                                        onSelectionModelChange={(newSelection) => {
                                            setStockList(newSelection.map(row => {
                                                let Ids = ""
                                                stockListData.forEach(item => {
                                                    if (row === item.id) {
                                                        Ids = item.id;
                                                    }
                                                })
                                                return Ids;
                                            }));
                                        }}
                                    />
                                }
                            </Box>
                        </TabPanel>
                        <TabPanel value="1">
                            <Box style={{ height: 450, width: '100%' }}>
                                {
                                    stockListData &&
                                    <DataGrid
                                        sx={{
                                            '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '6px' },
                                            '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '12px' },
                                            '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '20px' },
                                        }}
                                        getRowHeight={() => 'auto'}
                                        rows={stockListData}
                                        columns={columns}
                                        pageSize={10}
                                        components={{ Toolbar: QuickSearchToolbar }}

                                    />
                                }
                            </Box>
                        </TabPanel>
                    </TabContext>
                </Card>
            </Container>
            <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmApprove} onClose={handleConfirmClose} action="Approve Stock Transfer Request" />
            <ConfirmationPopover onOpen={confirmOpen2} onConfirm={onConfirmReject} onClose={handleConfirmClose2} action="Reject Stock Transfer Request" />
        </>
    );
}
export default StockTransferApproval;
